// extracted by mini-css-extract-plugin
module.exports = {"careerSlide":"career-insights_careerSlide__PoRw_"};